import * as React from "react";
import { Admin, Resource } from "react-admin";
import { authProvider, dataProvider } from "./provider/index";
import { PlayersList, PlayersEdit, PlayersCreate } from "./data/players";
import {
  FootballersCreate,
  FootballersEdit,
  FootballerShowStats,
  FootballersList,
} from "./data/Footballers";
import SportsSoccer from "@material-ui/icons/SportsSoccer";
import PostAdd from "@material-ui/icons/PostAdd";
import NotFound from "./page/notfound";
import "./App.css";
import { createTheme } from "@material-ui/core/styles";
import { Menu } from "./custom/menu";
import { FootSkillLayout } from "./custom/layout";
import Dashboard from "./page/dashbord";
import { PostCreate, PostEdit, PostList, PostShow } from "./data/Post";
import CalendarToday from "@material-ui/icons/CalendarToday";
import GradeIcon from "@material-ui/icons/Grade";
import { createBrowserHistory as createHistory } from "history";
import LoginPage from "./page/LoginPage";
import SettingsPage from "./page/SettingsPage";
import { Route } from "react-router-dom";
import {
  SheduleCreate,
  SheduleEdit,
  SheduleList,
  SheduleShow,
} from "./data/Shedule";
const theme = createTheme({
  palette: {
    primary: {
      light: "#D95561",
      main: "#BE1E2D",
      dark: "#8F1722",
      contrastText: "#FFFFFF",
    },
    secondary: {
      light: "#59595C",
      main: "#2D2D2E",
      dark: "#1E1E1F",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#F9F9FB",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#2D2D2E",
      secondary: "#59595C",
    },
    divider: "#F2F2F2",
  },
  typography: {
    fontFamily: 'Onest, Inter, Arial, sans-serif',
  },
  sidebar: {
    width: 240,
    closedWidth: 55,
  },
  shape: {
    borderRadius: 8,
  },
  overrides: {
    MuiPaper: {
      rounded: { borderRadius: 8 },
      elevation1: { boxShadow: "0 2px 8px rgba(46,46,46,0.08)" },
    },
    MuiButton: {
      root: {
        borderRadius: 8,
        textTransform: "none",
        fontWeight: 600,
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: "1px solid #F2F2F2",
      },
      head: {
        color: "#2D2D2E",
        fontWeight: 700,
        backgroundColor: "#FFFFFF",
      },
    },
  },
});

const history = createHistory();

const App = () => (
  <Admin
    history={history}
    dashboard={Dashboard}
    menu={Menu}
    layout={FootSkillLayout}
    theme={theme}
    authProvider={authProvider}
    dataProvider={dataProvider}
    catchAll={NotFound}
    loginPage={LoginPage}
    customRoutes={[<Route exact path="/settings" component={SettingsPage} key="settings" />]}
  >
    <Resource
      options={{
        label: "Футболисты",
      }}
      icon={SportsSoccer}
      name="footballers"
      list={FootballersList}
      create={FootballersCreate}
      edit={FootballersEdit}
      show={FootballerShowStats}
    />
    <Resource
      options={{
        label: "Новости",
      }}
      icon={PostAdd}
      name="posts"
      list={PostList}
      create={PostCreate}
      edit={PostEdit}
      show={PostShow}
    />
    <Resource
      options={{
        label: "Расписание",
      }}
      icon={CalendarToday}
      name="scheduleas"
      list={SheduleList}
      create={SheduleCreate}
      edit={SheduleEdit}
      show={SheduleShow}
    />
    <Resource
      options={{
        label: "Достижения",
      }}
      icon={GradeIcon}
      name="players"
      list={PlayersList}
      create={PlayersCreate}
      edit={PlayersEdit}
    />
  </Admin>
);

export default App;
